module.exports = __webpack_public_path__ + "img/header_logo.415a5175.png";